function preferences_step1() {
  var self = this;

  this.init = function () {

    this.validateApplication();
    this.bindEvents();

  }

  this.validateApplication = function () {

    $("#preferences_step1").validate({

      onfocusout: false,
      onkeyup: false,
      onclick: false,

      // Make sure error messages relating to radio buttons are placed in the correct location
      errorPlacement: function(error, element) {
        if (element.attr("type") == "checkbox") {
          error.prependTo(element.parents("div.form-group"));
        } else {
          error.insertBefore(element);
        }
      },

      rules: {

      },

      messages: {

      },

      submitHandler: function(form) {
        grecaptcha.ready(function() {
          grecaptcha.execute('6LeP_rkUAAAAAO2GHVS31IwO4Zquu0aA7F0ZSYpc', {action: 'homepage'}).then(function(token) {
            jQuery('#preferences_step1').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            form.submit();
          });
        });

      }

    });

  }

  this.bindEvents = function () {

    $("#unsubscribe-link").on('click',function(e) {
      e.preventDefault();

      /* Make sure the form can't be double clicked & provide a spinner so the user knows the form is submitting */
      $("#unsubscribe-wrapper").remove();
      $("#loading-spinner").removeClass('d-none');

      jQuery('#preferences_step1').prepend('<input type="hidden" name="unsubscribe" value="1">');

      /* This submit goes directly to the validate routine which prepends the google recaptcha code */
      jQuery('#preferences_step1').submit();

    });

  }

}

module.exports = preferences_step1;
